module.exports = __webpack_public_path__ + "static/media/Juventus.f043a23f.png";